import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import DataTable from '../data-table/data-table';
import { formattedDate } from '../../utils/date-utils';
import TCCStatuses from './tcc-statuses';
import { FileTypes, readFile, SelectFile } from '../file-uploader/file-uploader';
import Modal from '../modal/modal';
import './tccs.css';
import { updateTCC, fetchSomeTccs, fetchAllTccs, downloadTCC } from './tcc.actions';
import { uploadFile } from '../section/section.actions';
import Loader from '../loader-component/loader';

class TCCs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            currentAttachments: {},
            summary: {},
        };
        this.createModalBody = this.createModalBody.bind(this);
    }

    getTotalOfAttachments(filteredActivities) {
        if (filteredActivities !== {} ) {
            const totalAttachments = Object.keys(filteredActivities).reduce((acc, cur)=>{
                return acc + Object.values(filteredActivities[cur].attachments).length;
            }, 0);
            return totalAttachments;
        } else {
            return 0;
        }
    }

    render() {
        const { tccs, pages, loading, all } = this.props;
        const { showModal } = this.state;
        return (
            <div className='classes-list-container'>
                <Loader show={ loading ? true : false } message={'Carregando, por favor aguarde...'} />
                <DataTable
                    className='tccs-table'
                    data={tccs}
                    allData={all}
                    pages={pages}
                    columns={this.COLUMNS}
                    manual
                    fetchMethod={this.props.fetchSomeTccs}
                    fetchAllMethod={this.props.fetchAllTccs}
                    exportName={`tccs-${moment().toISOString()}.csv`}
                />
                <Modal dialogStyle={{ backgroundColor: 'transparent' }} show={showModal} onClose={this.close}>
                    { this.createModalBody()}
                </Modal>
            </div>
        );
    }

    createModalBody() {
        const { currentAttachments } = this.state;

        const total = this.getTotalOfAttachments(currentAttachments);
        if (total === 0) {
            return (
                <div className='attachments-body'>
                    <span>Não existem anexos nesse TCC</span>
                </div>
            );
        } else {
            return (
                <div className='attachments-body'>
                    <div className='modal-header'>
                        <span>Anexos</span>
                        <i className='fa fa-times' onClick={this.close} title='Fechar'/>
                    </div>
                    { Object.keys(currentAttachments)
                        .map(id => {
                            return (
                                <div className='attach-wrapper' key={id}>
                                    <span>{currentAttachments[id].title}</span>
                                    {
                                        Object.values(currentAttachments[id].attachments)
                                            .map((a, i) => (
                                                <a key={i} href={a.url} target='_blank' className='unstyled'>
                                                    <span >{a.title}</span>
                                                </a>
                                            )
                                            )
                                    }
                                </div>
                            );
                        })
                    }
                </div>);
        }
    }

    close = () => {
        this.setState({ showModal: false });
    };

    COLUMNS = [
        { Header: 'Aluno', searchable: true, accessor: 'userName', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Email', searchable: true, accessor: 'userEmail', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Turma', searchable: true, accessor: 'className', Cell: row => <span title={row.value}>{row.value}</span>, width: 200 },
        { Header: 'Data expiração', accessor: 'endDate', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Progresso', accessor: 'progress', filterMethod: (filter, row) => parseInt(filter.value, 10) === row[filter.id], Cell: row => (
            <div className='percent-loader'>
                <div
                    className={`progress-bar ${row.value < 40 ? 'red' : row.value > 85 ? 'green' : 'yellow'}`}
                    style={{ width: `${row.value}%` }}>
                    <div className='percentage'>{row.value}%</div>
                </div>
            </div>
        ) },
        { Header: 'Anexos', accessor: 'attachments', exportable: false, sortable: false, filterable: false, Cell: row => (
            <div className={`attachments ${this.getTotalOfAttachments(row.value) !== 0 ? '' : 'faded'}`}
                disabled={this.getTotalOfAttachments(row.value) === 0 }
                onClick={()=> this.setState({ showModal: true, currentAttachments: row.value })}>
                <i className='fa fa-paperclip' />
                { `${row.value !== {} ? this.getTotalOfAttachments(row.value) : 0 } anexo${row.value !== {} && this.getTotalOfAttachments(row.value) > 1 ? 's' : '' }`}
            </div>
        ) },
        { Header: 'Situação', searchable: true, accessor: 'stage', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Trainer', searchable: true, accessor: 'trainerName', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Unidade', searchable: true, accessor: 'centerName', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Modelo', searchable: true, accessor: 'tccId', Cell: row => <span title={row.value}>{row.value}</span> },
        { Header: 'Ações', filterable: false, exportable: false, Cell: props => <ActionsCell {...props}/>, sortable: false },
    ];
}

const mapStateToProps = ({ tccs }) => {
    return {
        tccs: tccs.some.map(tcc => transform(tcc)),
        all: tccs.all,
        pages: tccs.pages,
        loading: tccs.loading,
    };
};
const mapDispatchToProps = dispatch => bindActionCreators({ fetchSomeTccs, fetchAllTccs }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TCCs);

class ActionsGroup extends React.Component {

    state = {
        evalTCC: null,
    };

    render() {
        const { evalTCC: tcc } = this.state;
        const { classId, userId, tccId, progress, userName } = this.props.original;
        const { TCCInitial, TCCFinal, submitted } = this.props.original.data;
        return (
            <React.Fragment>
                <div className='actions-row'>
                    <ReviewButton {...{ classId, userId, tccId, TCCInitial, progress, userName, downloadTCC: this.props.downloadTCC, submitted }} />
                    <button title='Avaliar' disabled={!submitted} onClick={() => this.setState({ evalTCC: this.props.original })}>
                        <i className='fa fa-thumbs-up' />
                    </button>
                    {TCCFinal &&
                        <button disabled={!TCCInitial} title='Revisão Final'>
                            <a download href={TCCFinal} target='_blank'>
                                <i className='fa fa-exclamation-triangle'/>
                            </a>
                        </button>
                    }
                </div>
                {tcc &&
                <EvalTCCModal
                    show={true}
                    tcc={tcc}
                    onClose={() => this.setState({ evalTCC: null })}
                />}
            </React.Fragment>
        );
    }
}

const ActionsCell = connect(null, dispatch => bindActionCreators({ downloadTCC }, dispatch))(ActionsGroup);

class EvaluateTCCModal extends React.Component {

    state = { evaluation: 'APPROVED', ...this.props.tcc };

    onChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    uploadFile = (file, type = FileTypes.PdfFile) => {
        return new Promise((resolve) => {
            this.props.uploadFile(file, uri => resolve(uri), type);
        });
    };

    onSubmit = async () => {
        const toSubmit = {
            evaluation: this.state.evaluation,
            evaluated: moment().toISOString(),
        };
        if (this.state.file) {
            const fileAsArrayBuffer = await readFile(this.state.file);
            const uri = await this.uploadFile(fileAsArrayBuffer);
            toSubmit.file = undefined;
            toSubmit.TCCFinal = uri;
        }
        this.props.updateTCC({
            userId: this.state.userId,
            classId: this.state.classId,
            tccs: { [this.state.tccId]: toSubmit },
        });
        this.props.onClose();
    };

    render() {
        return (
            <Modal {...this.props} dialogStyle={{ borderRadius: '4px' }}>
                <div className='modal-body tcc-section'>
                    <div className='modal-header'>
                        <span>Avaliar TCC</span>
                        <i className='fa fa-times' onClick={this.props.onClose} title='Fechar'/>
                    </div>
                    <div className='form-item'>
                        <span>Avaliação</span>
                        <select onChange={this.onChange} name='evaluation' value={this.state.evaluation}>
                            <option value='APPROVED'>Aprovado</option>
                            <option value='REJECTED'>Reprovado</option>
                        </select>
                    </div>
                    <div className='form-item'>
                        <span>Arquivo (pdf)</span>
                        {this.state.data.TCCFinal && !this.state.file && <a href={this.state.data.TCCFinal}>Arquivo atual</a>}
                        {this.state.file && <span>{this.state.file.name}</span>}
                        {<SelectFile
                            accept={FileTypes.PdfFile}
                            onChange={file => this.onChange({ target: { name: 'file', value: file } })}
                        />}
                        {this.state.TCCFinal && !this.state.file && <a href={this.state.TCCFinal} target='_blank'>Arquivo atual</a>}
                        {this.state.file && <span>{this.state.file.name}</span>}
                    </div>
                    <div className='modal-footer'>
                        <button className='cancel-btn' onClick={this.props.onClose}>Cancelar</button>
                        <button className='save-btn' onClick={this.onSubmit}>Salvar</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

const EvalTCCModal = connect(null, dispatch => bindActionCreators({ updateTCC, uploadFile }, dispatch))(EvaluateTCCModal);

function ReviewButton({ submitted, TCCInitial, downloadTCC, userId, classId, tccId, progress, userName }) {
    if (TCCInitial && !submitted) { // #EAD-127: regenerate submitted TCCs to fill modules dates (should remove this soon)
        return (
            <a download href={TCCInitial} target='_blank'>
                <button title='Revisar'>
                    <i className='fa fa-tags'/>
                </button>
            </a>
        );
    }
    return (
        <button
            disabled={progress === 0}
            onClick={() => downloadTCC(userId, classId, tccId, `${tccId}_${classId} - ${userName}`)}
            title='Revisar'
        >
            <i className='fa fa-tags'/>
        </button>
    );
}

const transform = enrollment => ({
    ...enrollment,
    startDate: formattedDate(enrollment.startDate),
    endDate: formattedDate(enrollment.endDate),
    stage: TCCStatuses[enrollment.stage],
    attachments: attachments(enrollment),
});

const attachments = (enrollment) => {
    const { attachments = {} } = enrollment;
    return attachments;
};



// WEBPACK FOOTER //
// ./src/components/tccs/tccs.js